import React from 'react';

interface InventoryFiltersProps {
  makes: string[];
  bodyStyles: string[];
  selectedMake: string;
  selectedBodyStyle: string;
  maxPrice: string;
  search: string;
  sortBy: string;
  labels: {
    searchPlaceholder: string;
    make: string;
    bodyStyle: string;
    maxPrice: string;
    sortBy: string;
    sortNewest: string;
    sortOldest: string;
    sortPriceLow: string;
    sortPriceHigh: string;
    reset: string;
    allMakes: string;
    allBodyStyles: string;
  };
  onSearchChange: (value: string) => void;
  onMakeChange: (value: string) => void;
  onBodyStyleChange: (value: string) => void;
  onMaxPriceChange: (value: string) => void;
  onSortChange: (value: string) => void;
  onReset: () => void;
}

const inputClass =
  'w-full rounded-md border border-gray-300 px-3 py-2 text-sm text-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-500';

const InventoryFilters: React.FC<InventoryFiltersProps> = ({
  makes,
  bodyStyles,
  selectedMake,
  selectedBodyStyle,
  maxPrice,
  search,
  sortBy,
  labels,
  onSearchChange,
  onMakeChange,
  onBodyStyleChange,
  onMaxPriceChange,
  onSortChange,
  onReset,
}) => {
  return (
    <section className="bg-white border border-gray-200 rounded-xl p-4 md:p-6 mb-6">
      <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
        <input
          className={inputClass}
          type="text"
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder={labels.searchPlaceholder}
        />

        <select
          className={inputClass}
          value={selectedMake}
          onChange={(e) => onMakeChange(e.target.value)}
        >
          <option value="">{labels.allMakes}</option>
          {makes.map((make) => (
            <option key={make} value={make}>
              {make}
            </option>
          ))}
        </select>

        <select
          className={inputClass}
          value={selectedBodyStyle}
          onChange={(e) => onBodyStyleChange(e.target.value)}
        >
          <option value="">{labels.allBodyStyles}</option>
          {bodyStyles.map((bodyStyle) => (
            <option key={bodyStyle} value={bodyStyle}>
              {bodyStyle}
            </option>
          ))}
        </select>

        <input
          className={inputClass}
          type="number"
          min="0"
          value={maxPrice}
          onChange={(e) => onMaxPriceChange(e.target.value)}
          placeholder={labels.maxPrice}
        />

        <select
          className={inputClass}
          value={sortBy}
          onChange={(e) => onSortChange(e.target.value)}
        >
          <option value="">{labels.sortBy}</option>
          <option value="year-desc">{labels.sortNewest}</option>
          <option value="year-asc">{labels.sortOldest}</option>
          <option value="price-asc">{labels.sortPriceLow}</option>
          <option value="price-desc">{labels.sortPriceHigh}</option>
        </select>
      </div>

      <div className="mt-4 flex justify-end">
        <button
          type="button"
          onClick={onReset}
          className="inline-flex items-center rounded-md border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100"
        >
          {labels.reset}
        </button>
      </div>
    </section>
  );
};

export default InventoryFilters;
